// Generated by `npm --prefix converter-site run generate`. Do not edit.
// Source: reference/fixtures/

import type { Direction } from '../../../reference/src/browser/contract.ts';

/** One published worked example, as the guide publishes it. */
export interface FixtureExample {
  readonly mappingId: string;
  readonly name: string;
  /** The openEHR side, verbatim. */
  readonly openehr: string;
  /** The FHIR side, verbatim. */
  readonly fhir: string;
  /** The directions the repository asserts this pair in. */
  readonly directions: readonly Direction[];
}

export const FIXTURE_CATALOG: readonly FixtureExample[] = [
  {
    mappingId: "code-phrase-to-coding",
    name: "01-snomed-concept",
    openehr: "{\n  \"_type\": \"CODE_PHRASE\",\n  \"terminology_id\": {\n    \"value\": \"http://snomed.info/sct\"\n  },\n  \"code_string\": \"271737000\",\n  \"preferred_term\": \"Anemia\"\n}",
    fhir: "{\n  \"system\": \"http://snomed.info/sct\",\n  \"code\": \"271737000\",\n  \"display\": \"Anemia\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "code-phrase-to-coding",
    name: "02-versioned-system",
    openehr: "{\n  \"_type\": \"CODE_PHRASE\",\n  \"terminology_id\": {\n    \"value\": \"http://loinc.org\"\n  },\n  \"code_string\": \"718-7\",\n  \"preferred_term\": \"Hemoglobin [Mass/volume] in Blood\"\n}",
    fhir: "{\n  \"system\": \"http://loinc.org\",\n  \"version\": \"2.77\",\n  \"code\": \"718-7\",\n  \"display\": \"Hemoglobin [Mass/volume] in Blood\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "code-phrase-to-coding",
    name: "03-no-system",
    openehr: "{\n  \"_type\": \"CODE_PHRASE\",\n  \"terminology_id\": {\n    \"value\": \"unknown\"\n  },\n  \"code_string\": \"PROC123\",\n  \"preferred_term\": \"Local procedure 123\"\n}",
    fhir: "{\n  \"code\": \"PROC123\",\n  \"display\": \"Local procedure 123\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "code-phrase-to-coding",
    name: "04-whitespace-code",
    openehr: "{\n  \"_type\": \"CODE_PHRASE\",\n  \"terminology_id\": {\n    \"value\": \"http://example.org/facility/1111/local-procedure-codes\"\n  },\n  \"code_string\": \" PROC  123 \",\n  \"preferred_term\": \"Local procedure 123\"\n}",
    fhir: "{\n  \"system\": \"http://example.org/facility/1111/local-procedure-codes\",\n  \"code\": \"PROC 123\",\n  \"display\": \"Local procedure 123\"\n}",
    directions: [],
  },
  {
    mappingId: "dv-boolean-to-boolean",
    name: "01-smoker",
    openehr: "{\n  \"_type\": \"DV_BOOLEAN\",\n  \"value\": true\n}",
    fhir: "true",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-boolean-to-boolean",
    name: "02-false",
    openehr: "{\n  \"_type\": \"DV_BOOLEAN\",\n  \"value\": false\n}",
    fhir: "false",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-coded-text-to-codeable-concept",
    name: "01-simple-concept",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"Anemia\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://snomed.info/sct\"\n    },\n    \"code_string\": \"271737000\",\n    \"preferred_term\": \"Anemia\"\n  }\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://snomed.info/sct\",\n      \"code\": \"271737000\",\n      \"display\": \"Anemia\"\n    }\n  ],\n  \"text\": \"Anemia\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-coded-text-to-codeable-concept",
    name: "02-with-term-mappings",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"Anemia, unspecified\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://snomed.info/sct\"\n    },\n    \"code_string\": \"271737000\",\n    \"preferred_term\": \"Anemia\"\n  },\n  \"mappings\": [\n    {\n      \"_type\": \"TERM_MAPPING\",\n      \"match\": \"=\",\n      \"purpose\": {\n        \"_type\": \"DV_CODED_TEXT\",\n        \"value\": \"reimbursement\",\n        \"defining_code\": {\n          \"_type\": \"CODE_PHRASE\",\n          \"terminology_id\": {\n            \"value\": \"openehr\"\n          },\n          \"code_string\": \"670\"\n        }\n      },\n      \"target\": {\n        \"_type\": \"CODE_PHRASE\",\n        \"terminology_id\": {\n          \"value\": \"http://hl7.org/fhir/sid/icd-10\"\n        },\n        \"code_string\": \"D64.9\",\n        \"preferred_term\": \"Anaemia, unspecified\"\n      }\n    }\n  ]\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://snomed.info/sct\",\n      \"code\": \"271737000\",\n      \"display\": \"Anemia\"\n    },\n    {\n      \"system\": \"http://hl7.org/fhir/sid/icd-10\",\n      \"code\": \"D64.9\",\n      \"display\": \"Anaemia, unspecified\"\n    }\n  ],\n  \"text\": \"Anemia, unspecified\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-coded-text-to-codeable-concept",
    name: "03-user-selected",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"Anaemia, unspecified\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://hl7.org/fhir/sid/icd-10\"\n    },\n    \"code_string\": \"D64.9\",\n    \"preferred_term\": \"Anaemia, unspecified\"\n  },\n  \"mappings\": [\n    {\n      \"_type\": \"TERM_MAPPING\",\n      \"match\": \"?\",\n      \"target\": {\n        \"_type\": \"CODE_PHRASE\",\n        \"terminology_id\": {\n          \"value\": \"http://snomed.info/sct\"\n        },\n        \"code_string\": \"271737000\",\n        \"preferred_term\": \"Anemia\"\n      }\n    }\n  ]\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://snomed.info/sct\",\n      \"code\": \"271737000\",\n      \"display\": \"Anemia\"\n    },\n    {\n      \"system\": \"http://hl7.org/fhir/sid/icd-10\",\n      \"code\": \"D64.9\",\n      \"display\": \"Anaemia, unspecified\",\n      \"userSelected\": true\n    }\n  ],\n  \"text\": \"Anaemia, unspecified\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-coded-text-to-codeable-concept",
    name: "04-versioned-coding",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"Hemoglobin\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://loinc.org\"\n    },\n    \"code_string\": \"718-7\",\n    \"preferred_term\": \"Hemoglobin [Mass/volume] in Blood\"\n  }\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://loinc.org\",\n      \"version\": \"2.77\",\n      \"code\": \"718-7\",\n      \"display\": \"Hemoglobin [Mass/volume] in Blood\",\n      \"userSelected\": true\n    }\n  ],\n  \"text\": \"Hemoglobin\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-count-to-count",
    name: "01-pregnancies",
    openehr: "{\n  \"_type\": \"DV_COUNT\",\n  \"magnitude\": 3\n}",
    fhir: "{\n  \"value\": 3,\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"1\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-count-to-count",
    name: "02-with-comparator",
    openehr: "{\n  \"_type\": \"DV_COUNT\",\n  \"magnitude\": 10,\n  \"magnitude_status\": \">=\"\n}",
    fhir: "{\n  \"value\": 10,\n  \"comparator\": \">=\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"1\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-date-time-to-date-time",
    name: "01-observation-time",
    openehr: "{\n  \"_type\": \"DV_DATE_TIME\",\n  \"value\": \"2026-03-01T14:30:00Z\"\n}",
    fhir: "\"2026-03-01T14:30:00Z\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-date-time-to-date-time",
    name: "02-with-accuracy",
    openehr: "{\n  \"_type\": \"DV_DATE_TIME\",\n  \"value\": \"2026-03-01T14:30:00Z\",\n  \"accuracy\": \"PT5M\"\n}",
    fhir: "\"2026-03-01T14:30:00Z\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-date-time-to-date-time",
    name: "03-minute-precision",
    openehr: "{\n  \"_type\": \"DV_DATE_TIME\",\n  \"value\": \"2026-03-01T14:30+01:00\"\n}",
    fhir: "\"2026-03-01T14:30:00+01:00\"",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-date-time-to-date-time",
    name: "04-no-offset",
    openehr: "{\n  \"_type\": \"DV_DATE_TIME\",\n  \"value\": \"2026-03-01T14:30:00\"\n}",
    fhir: "\"2026-03-01T14:30:00+01:00\"",
    directions: [],
  },
  {
    mappingId: "dv-date-time-to-date-time",
    name: "05-hour-precision",
    openehr: "{\n  \"_type\": \"DV_DATE_TIME\",\n  \"value\": \"2026-03-01T14\"\n}",
    fhir: "\"2026-03-01T14:00:00+01:00\"",
    directions: [],
  },
  {
    mappingId: "dv-date-to-date",
    name: "01-birth-date",
    openehr: "{\n  \"_type\": \"DV_DATE\",\n  \"value\": \"1974-03-01\"\n}",
    fhir: "\"1974-03-01\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-date-to-date",
    name: "02-partial-date",
    openehr: "{\n  \"_type\": \"DV_DATE\",\n  \"value\": \"2026-04\"\n}",
    fhir: "\"2026-04\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-duration-to-duration",
    name: "01-six-months",
    openehr: "{\n  \"_type\": \"DV_DURATION\",\n  \"value\": \"P6M\"\n}",
    fhir: "{\n  \"value\": 6,\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mo\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-duration-to-duration",
    name: "02-multi-component",
    openehr: "{\n  \"_type\": \"DV_DURATION\",\n  \"value\": \"P1Y6M\"\n}",
    fhir: "{\n  \"value\": 18,\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mo\"\n}",
    directions: [],
  },
  {
    mappingId: "dv-duration-to-duration",
    name: "03-negative",
    openehr: "{\n  \"_type\": \"DV_DURATION\",\n  \"value\": \"-P3M\"\n}",
    fhir: "{\n  \"value\": -3,\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mo\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-duration-to-duration",
    name: "04-milliseconds",
    openehr: "{\n  \"_type\": \"DV_DURATION\",\n  \"value\": \"PT0.005S\"\n}",
    fhir: "{\n  \"value\": 5,\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"ms\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-identifier-to-identifier",
    name: "01-medical-record-number",
    openehr: "{\n  \"_type\": \"DV_IDENTIFIER\",\n  \"id\": \"12345\",\n  \"issuer\": \"http://example.org/hospital\",\n  \"type\": \"http://terminology.hl7.org/CodeSystem/v2-0203::MR\",\n  \"assigner\": \"http://example.org/org::OrgRef123\"\n}",
    fhir: "{\n  \"use\": \"usual\",\n  \"type\": {\n    \"coding\": [\n      {\n        \"system\": \"http://terminology.hl7.org/CodeSystem/v2-0203\",\n        \"code\": \"MR\"\n      }\n    ]\n  },\n  \"system\": \"http://example.org/hospital\",\n  \"value\": \"12345\",\n  \"period\": {\n    \"start\": \"2020-01-01\"\n  },\n  \"assigner\": {\n    \"identifier\": {\n      \"system\": \"http://example.org/org\",\n      \"value\": \"OrgRef123\"\n    }\n  }\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-identifier-to-identifier",
    name: "02-plain-issuer",
    openehr: "{\n  \"_type\": \"DV_IDENTIFIER\",\n  \"id\": \"A-99\",\n  \"issuer\": \"http://example.org/lab\"\n}",
    fhir: "{\n  \"system\": \"http://example.org/lab\",\n  \"value\": \"A-99\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-interval-to-range",
    name: "01-reference-range",
    openehr: "{\n  \"_type\": \"DV_INTERVAL\",\n  \"lower\": {\n    \"_type\": \"DV_QUANTITY\",\n    \"magnitude\": 3.5,\n    \"units\": \"mmol/L\",\n    \"units_system\": \"http://unitsofmeasure.org\",\n    \"units_display_name\": \"mmol/L\"\n  },\n  \"upper\": {\n    \"_type\": \"DV_QUANTITY\",\n    \"magnitude\": 5.0,\n    \"units\": \"mmol/L\",\n    \"units_system\": \"http://unitsofmeasure.org\",\n    \"units_display_name\": \"mmol/L\"\n  },\n  \"lower_unbounded\": false,\n  \"upper_unbounded\": false,\n  \"lower_included\": true,\n  \"upper_included\": true\n}",
    fhir: "{\n  \"low\": {\n    \"value\": 3.5,\n    \"unit\": \"mmol/L\",\n    \"system\": \"http://unitsofmeasure.org\",\n    \"code\": \"mmol/L\"\n  },\n  \"high\": {\n    \"value\": 5.0,\n    \"unit\": \"mmol/L\",\n    \"system\": \"http://unitsofmeasure.org\",\n    \"code\": \"mmol/L\"\n  }\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-interval-to-range",
    name: "02-upper-unbounded",
    openehr: "{\n  \"_type\": \"DV_INTERVAL\",\n  \"lower\": {\n    \"_type\": \"DV_QUANTITY\",\n    \"magnitude\": 140,\n    \"units\": \"mmol/L\",\n    \"units_system\": \"http://unitsofmeasure.org\",\n    \"units_display_name\": \"mmol/L\"\n  },\n  \"lower_unbounded\": false,\n  \"upper_unbounded\": true\n}",
    fhir: "{\n  \"low\": {\n    \"value\": 140,\n    \"unit\": \"mmol/L\",\n    \"system\": \"http://unitsofmeasure.org\",\n    \"code\": \"mmol/L\"\n  }\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "01-chest-xray",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"image/png\"\n  },\n  \"size\": 20416,\n  \"uri\": {\n    \"_type\": \"DV_URI\",\n    \"value\": \"https://example.org/images/chest-xray.png\"\n  },\n  \"alternate_text\": \"Chest X-ray, PA view\"\n}",
    fhir: "{\n  \"contentType\": \"image/png\",\n  \"url\": \"https://example.org/images/chest-xray.png\",\n  \"size\": \"20416\",\n  \"title\": \"Chest X-ray, PA view\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "02-gaps",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"image/png\"\n  },\n  \"size\": 20416,\n  \"data\": \"iVBORw0KGgo=\",\n  \"integrity_check\": \"2jmj7l5rSw0yVb/vlWAYkK/YBwk=\",\n  \"integrity_check_algorithm\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"openehr\"\n    },\n    \"code_string\": \"SHA-256\"\n  },\n  \"compression_algorithm\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"openehr\"\n    },\n    \"code_string\": \"gzip\"\n  },\n  \"charset\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_character-sets\"\n    },\n    \"code_string\": \"UTF-8\"\n  },\n  \"thumbnail\": {\n    \"_type\": \"DV_MULTIMEDIA\",\n    \"media_type\": {\n      \"_type\": \"CODE_PHRASE\",\n      \"terminology_id\": {\n        \"value\": \"IANA_media-types\"\n      },\n      \"code_string\": \"image/png\"\n    },\n    \"size\": 512\n  }\n}",
    fhir: "{\n  \"contentType\": \"image/png\",\n  \"data\": \"iVBORw0KGgo=\",\n  \"size\": \"20416\",\n  \"hash\": \"2jmj7l5rSw0yVb/vlWAYkK/YBwk=\",\n  \"creation\": \"2026-03-01T09:00:00Z\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "03-oversize",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"video/mp4\"\n  },\n  \"size\": 2147483647,\n  \"uri\": {\n    \"_type\": \"DV_URI\",\n    \"value\": \"https://example.org/media/whole-slide-scan.mp4\"\n  }\n}",
    fhir: "{\n  \"contentType\": \"video/mp4\",\n  \"url\": \"https://example.org/media/whole-slide-scan.mp4\",\n  \"size\": \"4294967296\"\n}",
    directions: [],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "04-media-details",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"video/mp4\"\n  },\n  \"size\": 1048576,\n  \"language\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"ISO_639-1\"\n    },\n    \"code_string\": \"en\"\n  },\n  \"uri\": {\n    \"_type\": \"DV_URI\",\n    \"value\": \"https://example.org/media/echocardiogram.mp4\"\n  }\n}",
    fhir: "{\n  \"contentType\": \"video/mp4\",\n  \"language\": \"en\",\n  \"url\": \"https://example.org/media/echocardiogram.mp4\",\n  \"size\": \"1048576\",\n  \"creation\": \"2026-03-01T09:00:00Z\",\n  \"height\": 1080,\n  \"width\": 1920,\n  \"frames\": 300,\n  \"duration\": 12.5,\n  \"pages\": 1\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "05-language-region-subtag",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"audio/mpeg\"\n  },\n  \"size\": 20416,\n  \"language\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"ISO_639-1\"\n    },\n    \"code_string\": \"pt\"\n  }\n}",
    fhir: "{\n  \"contentType\": \"audio/mpeg\",\n  \"language\": \"pt-BR\",\n  \"size\": \"20416\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-multimedia-to-attachment",
    name: "06-language-outside-code-set",
    openehr: "{\n  \"_type\": \"DV_MULTIMEDIA\",\n  \"media_type\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_media-types\"\n    },\n    \"code_string\": \"audio/mpeg\"\n  },\n  \"size\": 20416\n}",
    fhir: "{\n  \"contentType\": \"audio/mpeg\",\n  \"language\": \"gla\",\n  \"size\": \"20416\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-parsable-to-string",
    name: "01-hgvs",
    openehr: "{\n  \"_type\": \"DV_PARSABLE\",\n  \"value\": \"NM_000059.3:c.274G>A\",\n  \"formalism\": \"text/x-hgvs\"\n}",
    fhir: "{\n  \"value\": \"NM_000059.3:c.274G>A\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-proportion-to-ratio",
    name: "01-percent",
    openehr: "{\n  \"_type\": \"DV_PROPORTION\",\n  \"numerator\": 45,\n  \"denominator\": 100,\n  \"type\": 2,\n  \"precision\": 0\n}",
    fhir: "{\n  \"numerator\": {\n    \"value\": 45,\n    \"extension\": [\n      {\n        \"url\": \"http://hl7.org/fhir/StructureDefinition/quantity-precision\",\n        \"valueInteger\": 0\n      }\n    ]\n  },\n  \"denominator\": {\n    \"value\": 100\n  }\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-proportion-to-ratio",
    name: "02-with-units",
    openehr: "{\n  \"_type\": \"DV_PROPORTION\",\n  \"numerator\": 5,\n  \"denominator\": 100,\n  \"type\": 0\n}",
    fhir: "{\n  \"numerator\": {\n    \"value\": 5,\n    \"system\": \"http://unitsofmeasure.org\",\n    \"code\": \"mg\"\n  },\n  \"denominator\": {\n    \"value\": 100,\n    \"system\": \"http://unitsofmeasure.org\",\n    \"code\": \"mL\"\n  }\n}",
    directions: [],
  },
  {
    mappingId: "dv-quantity-to-money",
    name: "01-consultation-fee",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 125.0,\n  \"units\": \"EUR\",\n  \"units_system\": \"urn:iso:std:iso:4217\"\n}",
    fhir: "{\n  \"value\": 125.0,\n  \"currency\": \"EUR\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-quantity-to-quantity",
    name: "01-body-weight",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 72.5,\n  \"units\": \"kg\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"kg\",\n  \"precision\": 1\n}",
    fhir: "{\n  \"value\": 72.5,\n  \"unit\": \"kg\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"kg\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/quantity-precision\",\n      \"valueInteger\": 1\n    }\n  ]\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-quantity-to-quantity",
    name: "02-comparator-and-accuracy",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 0.5,\n  \"units\": \"mg\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"mg\",\n  \"magnitude_status\": \"<\",\n  \"accuracy\": 0.05,\n  \"accuracy_is_percent\": false\n}",
    fhir: "{\n  \"value\": 0.5,\n  \"comparator\": \"<\",\n  \"unit\": \"mg\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mg\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/quantity-accuracy\",\n      \"valueQuantity\": {\n        \"value\": 0.05,\n        \"system\": \"http://unitsofmeasure.org\",\n        \"code\": \"mg\"\n      }\n    }\n  ]\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-quantity-to-quantity",
    name: "03-approximate-and-percent-accuracy",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 120,\n  \"units\": \"mm[Hg]\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"mmHg\",\n  \"magnitude_status\": \"~\",\n  \"accuracy\": 10,\n  \"accuracy_is_percent\": true\n}",
    fhir: "{\n  \"value\": 120,\n  \"unit\": \"mmHg\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mm[Hg]\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/quantity-accuracy\",\n      \"valueQuantity\": {\n        \"value\": 10,\n        \"system\": \"http://unitsofmeasure.org\",\n        \"code\": \"%\"\n      }\n    }\n  ]\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-quantity-to-quantity",
    name: "04-comparator-ad",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 250,\n  \"units\": \"mL\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"mL\"\n}",
    fhir: "{\n  \"value\": 250,\n  \"comparator\": \"ad\",\n  \"unit\": \"mL\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mL\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-quantity-to-quantity",
    name: "05-percent-unit-accuracy",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 45,\n  \"units\": \"%\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"%\",\n  \"accuracy\": 2,\n  \"accuracy_is_percent\": false\n}",
    fhir: "{\n  \"value\": 45,\n  \"unit\": \"%\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"%\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/quantity-accuracy\",\n      \"valueQuantity\": {\n        \"value\": 2,\n        \"system\": \"http://unitsofmeasure.org\",\n        \"code\": \"%\"\n      }\n    }\n  ]\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-quantity-to-simple-quantity",
    name: "01-dose",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 500,\n  \"units\": \"mg\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"mg\"\n}",
    fhir: "{\n  \"value\": 500,\n  \"unit\": \"mg\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mg\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-quantity-to-simple-quantity",
    name: "02-modelling-error",
    openehr: "{\n  \"_type\": \"DV_QUANTITY\",\n  \"magnitude\": 500,\n  \"units\": \"mg\",\n  \"units_system\": \"http://unitsofmeasure.org\",\n  \"units_display_name\": \"mg\",\n  \"magnitude_status\": \">\"\n}",
    fhir: "{\n  \"value\": 500,\n  \"unit\": \"mg\",\n  \"system\": \"http://unitsofmeasure.org\",\n  \"code\": \"mg\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-state-to-codeable-concept",
    name: "01-completed",
    openehr: "{\n  \"_type\": \"DV_STATE\",\n  \"value\": {\n    \"_type\": \"DV_CODED_TEXT\",\n    \"value\": \"completed\",\n    \"defining_code\": {\n      \"_type\": \"CODE_PHRASE\",\n      \"terminology_id\": {\n        \"value\": \"openehr\"\n      },\n      \"code_string\": \"532\"\n    }\n  },\n  \"is_terminal\": true\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"openehr\",\n      \"code\": \"532\"\n    }\n  ],\n  \"text\": \"completed\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-state-to-codeable-concept",
    name: "02-versioned-and-user-selected",
    openehr: "{\n  \"_type\": \"DV_STATE\",\n  \"value\": {\n    \"_type\": \"DV_CODED_TEXT\",\n    \"value\": \"completed\",\n    \"defining_code\": {\n      \"_type\": \"CODE_PHRASE\",\n      \"terminology_id\": {\n        \"value\": \"openehr\"\n      },\n      \"code_string\": \"532\"\n    }\n  },\n  \"is_terminal\": false\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"openehr\",\n      \"version\": \"1.1.0\",\n      \"code\": \"532\",\n      \"userSelected\": true\n    }\n  ],\n  \"text\": \"completed\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "01-plain-note",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"Patient reports intermittent headache.\"\n}",
    fhir: "{\n  \"value\": \"Patient reports intermittent headache.\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "02-markdown-with-language",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"**Allergy:** penicillin\",\n  \"formatting\": \"markdown\",\n  \"language\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"ISO_639-1\"\n    },\n    \"code_string\": \"en\"\n  }\n}",
    fhir: "{\n  \"value\": \"**Allergy:** penicillin\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/rendering-markdown\",\n      \"valueMarkdown\": \"**Allergy:** penicillin\"\n    },\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/language\",\n      \"valueCode\": \"en\"\n    }\n  ]\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "03-encoded-and-linked",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"Single line only\",\n  \"formatting\": \"plain_no_newlines\",\n  \"encoding\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"IANA_character-sets\"\n    },\n    \"code_string\": \"UTF-8\"\n  },\n  \"hyperlink\": {\n    \"_type\": \"DV_URI\",\n    \"value\": \"https://example.org/guideline\"\n  },\n  \"mappings\": [\n    {\n      \"_type\": \"TERM_MAPPING\",\n      \"match\": \"=\",\n      \"target\": {\n        \"_type\": \"CODE_PHRASE\",\n        \"terminology_id\": {\n          \"value\": \"http://snomed.info/sct\"\n        },\n        \"code_string\": \"25064002\"\n      }\n    }\n  ]\n}",
    fhir: "{\n  \"value\": \"Single line only\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "04-language-region-subtag",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"Blood pressure recorded at triage\",\n  \"language\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"ISO_639-1\"\n    },\n    \"code_string\": \"en\"\n  }\n}",
    fhir: "{\n  \"value\": \"Blood pressure recorded at triage\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/language\",\n      \"valueCode\": \"en-GB\"\n    }\n  ]\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "05-language-outside-code-set",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"Note dictated in Scottish Gaelic\"\n}",
    fhir: "{\n  \"value\": \"Note dictated in Scottish Gaelic\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/language\",\n      \"valueCode\": \"gla\"\n    }\n  ]\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-text-to-string",
    name: "06-rendering-xhtml",
    openehr: "{\n  \"_type\": \"DV_TEXT\",\n  \"value\": \"Allergy: penicillin\"\n}",
    fhir: "{\n  \"value\": \"Allergy: penicillin\",\n  \"extension\": [\n    {\n      \"url\": \"http://hl7.org/fhir/StructureDefinition/rendering-xhtml\",\n      \"valueString\": \"<p><b>Allergy:</b> penicillin</p>\"\n    }\n  ]\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-time-to-time",
    name: "01-collection-time",
    openehr: "{\n  \"_type\": \"DV_TIME\",\n  \"value\": \"14:30:00+01:00\"\n}",
    fhir: "{\n  \"value\": \"14:30:00\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-time-to-time",
    name: "02-high-precision",
    openehr: "{\n  \"_type\": \"DV_TIME\",\n  \"value\": \"14:30:00.123\"\n}",
    fhir: "{\n  \"value\": \"14:30:00.123456789\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "dv-time-to-time",
    name: "03-minute-precision",
    openehr: "{\n  \"_type\": \"DV_TIME\",\n  \"value\": \"14:30\"\n}",
    fhir: "{\n  \"value\": \"14:30:00\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-time-to-time",
    name: "04-hour-precision",
    openehr: "{\n  \"_type\": \"DV_TIME\",\n  \"value\": \"14\"\n}",
    fhir: "{\n  \"value\": \"14:00:00\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "dv-uri-to-uri",
    name: "01-web-address",
    openehr: "{\n  \"_type\": \"DV_URI\",\n  \"value\": \"https://example.org/guideline/anaemia\"\n}",
    fhir: "\"https://example.org/guideline/anaemia\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "dv-uri-to-uri",
    name: "02-ehr-uri",
    openehr: "{\n  \"_type\": \"DV_EHR_URI\",\n  \"value\": \"ehr://8f3c6b1e-1e5a-4a6b-9a3e-2b6f0c1d4e77/compositions/1\"\n}",
    fhir: "\"ehr://8f3c6b1e-1e5a-4a6b-9a3e-2b6f0c1d4e77/compositions/1\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "integer-to-integer",
    name: "01-count",
    openehr: "42",
    fhir: "42",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "integer64-to-integer64",
    name: "01-in-range",
    openehr: "2000000000",
    fhir: "\"2000000000\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "integer64-to-integer64",
    name: "02-beyond-32-bit",
    openehr: "4294967296",
    fhir: "\"4294967296\"",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "integer64-to-integer64",
    name: "03-int32-max",
    openehr: "2147483647",
    fhir: "\"2147483647\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "integer64-to-integer64",
    name: "04-int32-min",
    openehr: "-2147483648",
    fhir: "\"-2147483648\"",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "link-to-reference",
    name: "01-problem-link",
    openehr: "{\n  \"_type\": \"LINK\",\n  \"meaning\": {\n    \"_type\": \"DV_TEXT\",\n    \"value\": \"Related problem\"\n  },\n  \"type\": {\n    \"_type\": \"DV_TEXT\",\n    \"value\": \"problem\"\n  },\n  \"target\": {\n    \"_type\": \"DV_EHR_URI\",\n    \"value\": \"ehr://8f3c6b1e-1e5a-4a6b-9a3e-2b6f0c1d4e77/compositions/2\"\n  }\n}",
    fhir: "{\n  \"reference\": \"ehr://8f3c6b1e-1e5a-4a6b-9a3e-2b6f0c1d4e77/compositions/2\",\n  \"display\": \"Related problem\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "null-flavour-to-data-absent-reason",
    name: "01-masked",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"masked\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"openehr\"\n    },\n    \"code_string\": \"272\"\n  }\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://terminology.hl7.org/CodeSystem/data-absent-reason\",\n      \"code\": \"masked\"\n    }\n  ],\n  \"text\": \"masked\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "null-flavour-to-data-absent-reason",
    name: "02-no-information",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"no information\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"openehr\"\n    },\n    \"code_string\": \"271\"\n  }\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://terminology.hl7.org/CodeSystem/data-absent-reason\",\n      \"code\": \"unknown\"\n    }\n  ],\n  \"text\": \"no information\"\n}",
    directions: ["toFhir"],
  },
  {
    mappingId: "null-flavour-to-data-absent-reason",
    name: "03-asked-unknown",
    openehr: "{\n  \"_type\": \"DV_CODED_TEXT\",\n  \"value\": \"asked but unknown\",\n  \"defining_code\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"openehr\"\n    },\n    \"code_string\": \"253\"\n  }\n}",
    fhir: "{\n  \"coding\": [\n    {\n      \"system\": \"http://terminology.hl7.org/CodeSystem/data-absent-reason\",\n      \"code\": \"asked-unknown\"\n    }\n  ],\n  \"text\": \"asked but unknown\"\n}",
    directions: ["toOpenehr"],
  },
  {
    mappingId: "real-to-decimal",
    name: "01-magnitude",
    openehr: "72.5",
    fhir: "72.5",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "term-mapping-to-coding",
    name: "01-icd10-equivalent",
    openehr: "{\n  \"_type\": \"TERM_MAPPING\",\n  \"match\": \"=\",\n  \"target\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://hl7.org/fhir/sid/icd-10\"\n    },\n    \"code_string\": \"D64.9\",\n    \"preferred_term\": \"Anaemia, unspecified\"\n  }\n}",
    fhir: "{\n  \"system\": \"http://hl7.org/fhir/sid/icd-10\",\n  \"code\": \"D64.9\",\n  \"display\": \"Anaemia, unspecified\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "term-mapping-to-coding",
    name: "02-with-purpose",
    openehr: "{\n  \"_type\": \"TERM_MAPPING\",\n  \"match\": \"=\",\n  \"purpose\": {\n    \"_type\": \"DV_CODED_TEXT\",\n    \"value\": \"reimbursement\",\n    \"defining_code\": {\n      \"_type\": \"CODE_PHRASE\",\n      \"terminology_id\": {\n        \"value\": \"openehr\"\n      },\n      \"code_string\": \"670\"\n    }\n  },\n  \"target\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://hl7.org/fhir/sid/icd-10\"\n    },\n    \"code_string\": \"D64.9\",\n    \"preferred_term\": \"Anaemia, unspecified\"\n  }\n}",
    fhir: "{\n  \"system\": \"http://hl7.org/fhir/sid/icd-10\",\n  \"code\": \"D64.9\",\n  \"display\": \"Anaemia, unspecified\"\n}",
    directions: ["toFhir","toOpenehr"],
  },
  {
    mappingId: "term-mapping-to-coding",
    name: "03-versioned-target",
    openehr: "{\n  \"_type\": \"TERM_MAPPING\",\n  \"match\": \"=\",\n  \"target\": {\n    \"_type\": \"CODE_PHRASE\",\n    \"terminology_id\": {\n      \"value\": \"http://loinc.org\"\n    },\n    \"code_string\": \"718-7\",\n    \"preferred_term\": \"Hemoglobin [Mass/volume] in Blood\"\n  }\n}",
    fhir: "{\n  \"system\": \"http://loinc.org\",\n  \"version\": \"2.77\",\n  \"code\": \"718-7\",\n  \"display\": \"Hemoglobin [Mass/volume] in Blood\"\n}",
    directions: ["toOpenehr"],
  },
];
